import React from "react";

function DeleteConfirmationModal({ isOpen, onClose, onConfirm, mapName, mapArabicName, isLoading }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-900 bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="px-6 py-4">
          <div className="flex items-center justify-center w-12 h-12 mx-auto bg-rose-100 rounded-full mb-4">
            <svg className="w-6 h-6 text-rose-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          
          <h3 className="text-lg font-semibold text-slate-800 text-center mb-2">
            Delete Capability Map
          </h3>
          
          <p className="text-sm text-slate-600 text-center mb-4">
            Are you sure you want to delete this capability map?
          </p>
          
          <div className="bg-slate-50 rounded-lg p-3 mb-4">
            <p className="font-medium text-slate-800 text-center">{mapName}</p>
            {mapArabicName && (
              <p className="text-sm text-slate-500 text-center" dir="rtl">{mapArabicName}</p>
            )}
          </div>
          
          <p className="text-xs text-slate-500 text-center mb-6">
            This action cannot be undone. All phases and items associated with this map will also be deleted.
          </p>

          <div className="flex justify-end space-x-2">
            <button
              onClick={onClose}
              className="btn border-slate-200 hover:border-slate-300 text-slate-600"
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="btn bg-rose-500 hover:bg-rose-600 text-white min-w-[120px]"
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Deleting...
                </span>
              ) : (
                "Delete Permanently"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmationModal;